import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import {
  createContext,
  FunctionComponent,
  ReactElement,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useLocation, useParams } from "react-router-dom";

export const RadarViewReportContext = createContext(null);

type Props = {
  children: ReactElement;
};

const RadarViewReportProvider: FunctionComponent<Props> = ({ children }) => {
  const { id } = useParams();
  const { search } = useLocation();
  const [paramId, setParamId] = useState(""); // get param id from SDK profile
  const getId = new URLSearchParams(search).get("id");

  useEffect(() => {
    if (getId) {
      setParamId(getId);
    } else {
      setParamId("");
    }
  }, [search]);

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["radar_view_profile_report"],
    enabled: !!id || !!paramId,
    // staleTime: 30000,
    queryFn: async () => {
      const { data } = await Api.get(
        `onboarding/profiles/${id || paramId}/reports`,
      );

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <RadarViewReportContext.Provider value={contextValue}>
      {children}
    </RadarViewReportContext.Provider>
  );
};

export default RadarViewReportProvider;
